<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="tableData"
      style="width: 100.1%"
    ></Table>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
var tableDataVue = {};
export default {
  name: "tableFilestore",
  data() {
    return {
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      accountIds: [],
      columns: [
        {
          title: this.$t("RAM.GCP.FileStore.accountName"),
          key: "accountName",
        },
        {
          title: this.$t("RAM.GCP.FileStore.accountIdString"),
          key: "accountIdString",
        },
        {
          title: this.$t("RAM.GCP.FileStore.region"),
          key: "region",
        },
        {
          title: this.$t("RAM.GCP.FileStore.name"),
          key: "name",
        },
        {
          title: this.$t("RAM.GCP.FileStore.description"),
          key: "description",
        },
        {
          title: this.$t("RAM.GCP.FileStore.state"),
          key: "state",
        },
        {
          title: this.$t("RAM.GCP.FileStore.capacity"),
          key: "capacity",
        },
        {
          title: this.$t("RAM.GCP.FileStore.tier"),
          key: "tier",
        },
        {
          title: this.$t("RAM.GCP.FileStore.projectId"),
          key: "projectId",
        },
        {
          title: this.$t("RAM.GCP.FileStore.filestoreCreatetime"),
          key: "filestoreCreatetime",
        },
      ],
      tableData: [],
    };
  },
  beforeCreate: function () {
    tableDataVue = this;
  },
  created() {
    // 获取搜索内容
    eventBus.$on("companyId", function (val) {
      tableDataVue.companyId = val;
    });
    eventBus.$on("accountName", function (val) {
      tableDataVue.accountName = val;
    });
    eventBus.$on("filestoreName", function (val) {
      tableDataVue.filestoreName = val;
    });
  },
  mounted: function () {
    // tableDataVue.getData();
  },
  methods: {
    showAll: function () {
      tableDataVue.getData();
    },
    // 分页显示数据
    /****************************************************/
    getData: function () {
      // 获取搜索内容
      eventBus.$on("companyId", function (val) {
        tableDataVue.companyId = val;
      });
      eventBus.$on("accountName", function (val) {
        tableDataVue.accountName = val;
      });
      eventBus.$on("filestoreName", function (val) {
        tableDataVue.filestoreName = val;
      });
      this.$api.resourceManagement
        .selectFileStoreByPage({
          accountName: tableDataVue.accountName,
          companyId: tableDataVue.companyId,
          name: tableDataVue.filestoreName,
          pageNum: this.current,
          pageSize: this.pageSize,
        })
        .then((res) => {
          this.tableData = res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        });
    },
    changePage: function (current) {
      this.current = current;
      tableDataVue.getData();
    },
    changeSize: function (pageSize) {
      this.pageSize = pageSize;
      tableDataVue.getData();
    },
  },
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/gcp/filestore/TableFilestore.vue